import React from "react";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { getIn } from "formik";
import {
  TextField,
  IconButton,
  InputAdornment,
  useTheme,
  Box,
} from "@material-ui/core";

const Step1 = ({
  Formdata,
  showPassword,
  setshowPassword,
  checkEmailAvailability,
  emailAvailable,
  setEmailAvailable
}) => {
  // const emailField = useRef(null);

  async function checkValidEMail(email) {
    try {
      let invalidDomain=  email.includes("karenkey")
      if (invalidDomain) {
        setEmailAvailable(true);
      } else {
        setEmailAvailable(false);
      }
      return 
    } catch (err) {
      // seterror(true);
      // enqueueSnackbar(`Something went wrong ${err}`, {
      //   variant: "error",
      //   autoHideDuration: 5000,
      // });
    }
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPassword = () => {
    setshowPassword(!showPassword);
  };

  const theme = useTheme();

  return (
    <>
    <Box
      component="form"
      // sx={{
      //   '& .MuiTextField-root': { m: 1, width: '25ch' },
      // }}
      noValidate
      autoComplete="off"
    >
      <TextField
        required
        fullWidth
        autoFocus
        autoComplete="nope"
        // ref={emailField}
      //   onFocus = {(e) => {
      //     if (e.target.value !== "") {
      //       checkEmailAvailability(e.target.value);
      //     }
      //     // if(e.target.autocomplete)
      //     // {
      //     //   e.target.autocomplete = "whatever";
      //     // }
       
      //  }}
        name={`email`}
        label="Business Email"
        value={Formdata.values.email || ""}
        onBlur={(e) => {
          if (e.target.value !== "") {
            // checkEmailAvailability(e.target.value);
            checkValidEMail(e.target.value)
          }

          Formdata.handleBlur(e);
        }}
        variant="outlined"
        onChange={(e) => {
          if (e.target.value !== "") {
          //   checkEmailAvailability(e.target.value);
          checkValidEMail(e.target.value)
          }
          Formdata.handleChange(e);
        }}
        
        helperText={
          (
            Boolean(emailAvailable) &&
            "Please enter valid email domain") ||
          (getIn(Formdata.touched, `email`) &&
            getIn(Formdata.errors, `email`))
        }
        error={
          (Boolean(emailAvailable) &&
            "Please enter valid email domain") ||
          (Boolean(getIn(Formdata.errors, `email`)) &&
            getIn(Formdata.touched, `email`))
        }
        FormHelperTextProps={{
          style: {
            color:
              !(
                // (Boolean(emailAvailable) &&
                //   "Email registered with us already") ||
                (getIn(Formdata.touched, `email`) &&
                  getIn(Formdata.errors, `email`))
              ) && theme.palette.primary.dark,
          },
        }}
        size="small"
      />
      <TextField
        type={showPassword ? "text" : "password"}
        variant="outlined"
        size="small"
        label="Password"
        required
        value={Formdata.values.password ||""}
        fullWidth
        helperText={
          getIn(Formdata.touched, `password`) &&
          getIn(Formdata.errors, `password`)
        }
        error={
          Boolean(getIn(Formdata.errors, `password`)) &&
          getIn(Formdata.touched, `password`)
        }
        name="password"
        onBlur={(e) => {
          Formdata.handleBlur(e);
        }}
        onChange={(e) => {
          Formdata.handleChange(e);
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      </Box>
    </>
  );
};

export default Step1;
